/**
 * Notification item DTO
 */
export interface NotificationItemDTO {
  notificationId: number;
  type: NotificationType;
  title: string;
  createdDate: Date;
  /** Created date formated to show how long the notification was created */
  formatedCreatedDate: string;
  isRead: boolean;
  /** For announcements, this would be the announcement ID */
  typeReferenceId: number | null;
  /** URL or route to redirect when notification is clicked */
  notificationRedirectRoute: string | null;
}

/**
 * Notification types
 */
export enum NotificationType {
  System = 1,
  Announcement = 2,
}
